import type { FormatType } from './useRichTextEditor';

export const isDisabled = (
  formatTypes: FormatType[],
  activationFunction: (formatType: FormatType) => boolean | undefined
) => {
  return formatTypes.reduce((accumulator: boolean, formatType: FormatType) => {
    return accumulator || activationFunction(formatType) || false;
  }, false);
};
